"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LabelValidator = require("./LabelValidator");
Object.keys(_LabelValidator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LabelValidator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _LabelValidator[key];
    }
  });
});